import { render } from "./DashboardDetails.vue?vue&type=template&id=ca70107c"
import script from "./DashboardDetails.vue?vue&type=script&lang=js"
export * from "./DashboardDetails.vue?vue&type=script&lang=js"
script.render = render

export default script